import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setStep, setQuoteData } from '../../../../actions/salesActions';
import KPDropdown from '../../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';
import './ClaimsHistory.css';
import { postToController } from '../../../../actions/apiActions';
import { PRODUCT_HOME_CONTENT } from '../../../../constants/constants';

class ClaimsHistory extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        let items = [];
        let selection = this.props.sales.claimsSelection;
        this.state = {
            items,
            selection,
            claimsCount: this.props.sales.claimsCount,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleListSelection = this.handleListSelection.bind(this);
        this.getSelectionItems = this.getSelectionItems.bind(this);
    }

    async componentWillMount() {
        this.getSelectionItems();
        this.checkSubmit();
    } 

    checkSubmit() {
        let valid = (this.state.selection !== null && this.state.selection !== undefined);
        this.setState({ nextDisabled: !valid });
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            this.props.dispatchAction(
                setQuoteData({
                    claimsSelection: this.state.selection,
                    claimsCount: this.state.claimsCount
                })
            );

            if (Number(this.state.claimsCount) >= 3 || (Number(this.state.claimsCount > 0) && this.props.sales.propertyBorders.river)) {
                await this.props.dispatchAction(handleNextStep());
            }
            else {
                if (!this.props.sales.buildingContinueQuote) {
                    await this.props.dispatchAction(setStep(12));
                }
                else {
                    await this.props.dispatchAction(setStep(2));
                }
            }
        }
    }

    handleListSelection(e: Number) {
        let item = this.state.items.filter(x => x.id === e)[0];
        let value = Number(item.description.replace("+",""))
        this.setState({
            claimsCount: value,
            selection: item,
            }, () => { this.checkSubmit() }
        );
    }

    async getSelectionItems() {
        let dropDownItems: IDropdownData[] = [];

        await postToController(this.props.dispatch, 'GetClaimCounts', JSON.stringify({})).then(async (response) => {
            response.forEach((item, index) => {
                dropDownItems.push({
                    id: item.id,
                    description: item.description,
                    productName: item.description,
                    image: ""
                });
            });
            this.setState({ items: dropDownItems });
        })
    }

    public render() {
        return (
            <div className="container">
                {this.props.sales.addProduct === PRODUCT_HOME_CONTENT &&
                    <div className="mt-4 text-center">
                        Thanks, now tell us how many home contents claims you’ve had in the past 3 years.
                    </div> || <div className="mt-4 text-center">
                        Thanks, now tell us how many buildings claims you’ve had in the past 3 years.
                    </div>
                }

                <div className="mt-4">
                    <KPDropdown
                        id="listClaimsCount"
                        isBordered={true}
                        showLabelAfterSelection={true}
                        showLabelInside={false}
                        showLabelOutside={true}
                        labelAfterSelection="Number of claims"
                        label="Number of claims"
                        title="Number of claims"
                        data={this.state.items}
                        selectedValue={this.state.selection}
                        handleSelection={(e) => this.handleListSelection(Number(e))}
                    />
                </div>

                <div className="row">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsHistory);